const paramIdIsCurrentPageId = ({ paramId, pageId }) => paramId === pageId

export default paramIdIsCurrentPageId